import {
  InsertChartOutlined,
  BarChart,
  People,
  ViewCarousel,
  Theaters,
  Timelapse,
  List,
  TableChart,
  Repeat,
  NotificationsActive,
} from 'Components/Atoms/Icons';
import LightReservationsIcon from 'Components/Atoms/Icons/LightReservations';
import { dateHelper } from 'utils/helper';

export const paths = [
  {
    id: 'tablePlan',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/tablePlan`,
    name: 'Table Plan',
    icon: <ViewCarousel />,
  },
  {
    id: 'timeTable',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/timeTable`,
    name: 'Time Table',
    icon: <BarChart style={{ transform: 'rotate(90deg)' }} />,
  },
  {
    id: 'guestbook',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/guestbook`,
    name: 'Gästebuch',
    icon: <People />,
    disableOnShuffle: true,
    authenticate: 'dashboard.guestBook.read',
  },
  {
    id: 'list',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/list`,
    name: 'Reservierungen',
    icon: <TableChart />,
    disableOnShuffle: true,
  },
  {
    id: 'statistics',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/statistics`,
    name: 'Statistics',
    icon: <InsertChartOutlined />,
    disableOnShuffle: true,
  },

  {
    id: 'largeGroups',
    linkTo: (rId: string) => `/${rId}/reservations/largeGroups`,
    name: 'Offene Anfragen & Letzte Reservierungen',
    icon: <Timelapse />,
    disableOnShuffle: false,
  },
  {
    id: 'regularTables',
    linkTo: (rId: string) => `/${rId}/reservations/regularTables`,
    name: 'Stammtische',
    icon: <Repeat />,
    disableOnShuffle: false,
  },
  {
    id: 'visitWishes',
    linkTo: (rId: string) => `/${rId}/reservations/visitWishes`,
    name: 'Besuchswünsche',
    icon: <NotificationsActive />,
    disableOnShuffle: false,
    requiredApp: 'visit_wishes' as const,
  },
  // {
  //   id: "waitingList",
  //   linkTo: (rId:string,date?:string) => `/${rId}/reservations/${date || dateHelper()}/waitingList`,
  //   name: "Waiting List",
  //   icon: <AccessAlarm />
  // },
];

export const lightPaths = [
  {
    id: 'reservations',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/reservationList`,
    name: 'Reservations',
    icon: <LightReservationsIcon />,
  },
  {
    id: 'guestbook',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/guestbook`,
    name: 'Gästebuch',
    icon: <People />,
    authenticate: 'dashboard.guestBook.read',
  },
  {
    id: 'statistics',
    linkTo: (rId: string, date?: string) =>
      `/${rId}/reservations/${date || dateHelper()}/statistics`,
    name: 'Statistics',
    icon: <InsertChartOutlined />,
  },
];
